import { events } from './events';
import { Module } from './framework/module';
import { PlEvent } from './models/pl.event';
import { delay } from './utils/delay.fn';

export class FinishOverlayModule extends Module {
  private overlay$ = document.querySelector('#finished');
  private close$ = this.overlay$?.querySelector<HTMLButtonElement>('.close');
  private downloadResult$ =
    this.overlay$?.querySelector<HTMLButtonElement>('#download-result');
  private convertMore$ =
    this.overlay$?.querySelector<HTMLButtonElement>('#convert-more');
  private openInput$ = document.querySelector<HTMLInputElement>('#open-input');
  private lastResultType: 'file' | 'zip' | undefined;

  async onInit() {
    this.close$?.addEventListener('click', () => this.onClose());
    this.convertMore$?.addEventListener('click', () => this.onConvertMore());
    this.downloadResult$?.addEventListener('click', () =>
      this.onDownloadResultClick()
    );

    events.on('convert-finished', () => this.onConvertFinished());
    events.on('downloaded-file', (event) => this.onResultDownloaded(event));
    events.on('downloaded-zip', (event) => this.onResultDownloaded(event));
  }

  private show() {
    this.overlay$?.classList.add('show');
  }

  private async hide() {
    this.overlay$?.classList.remove('show');

    await delay(1);

    events.emit('convert-more');
  }

  private onConvertFinished() {
    this.show();
  }

  private onClose() {
    this.hide();
  }

  private onResultDownloaded({ type }: { type: 'file' | 'zip' }) {
    this.lastResultType = type;
    setTimeout(() => this.downloadResult$?.classList.remove('hide'), 1000);
  }

  private onDownloadResultClick() {
    document.dispatchEvent(new PlEvent({ goal: 'missed download' }));

    switch (this.lastResultType) {
      case 'file':
        return events.emit('download-file');
      case 'zip':
        return events.emit('redownload-zip');
      default:
        return;
    }
  }

  private onConvertMore() {
    this.hide();
    document.dispatchEvent(new PlEvent({ goal: 'convert more' }));

    this.openInput$?.click();
  }
}
